import OrganizationDocument from "./organizationDocument";
import {RelationType} from "../../../common/models/relationType";
import Share from "../../../common/models/share";

export default class Certificate extends OrganizationDocument {
  modelKey = 'certificate';
  collectionKey = 'certificates';
  foundation_layer_dependents?: { id: string, title: string }[];

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    return {
      'shares': {type: Share, relationType: RelationType.collection},
    };
  }

  static get displayName(): string {
    return 'Certificate';
  }

  get isCertificate(): boolean {
    return true;
  }

  get classKey(): string {
    return 'certificate';
  }

  get rootName(): string {
    return 'certificate';
  }

  hasFoundationLayerDependents?(): boolean {
    return this.foundation_layer_dependents && this.foundation_layer_dependents.length > 0;
  }
}